"use client";

import React from "react";
import { Mail } from "lucide-react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
export default function Technicalquotecta() {
  const {
    lang
  } = useLanguage();
  const eyebrow = pick(lang, {
    en: "Engineering Support",
    zh: "工程技术支持",
    es: "Soporte de ingeniería",
    de: "Technische Unterstützung",
    fr: "Support technique",
    pt: "Suporte de engenharia"
  });
  const heading = pick(lang, {
    en: "Need a Custom Mesh Quote?",
    zh: "需要定制丝网报价？",
    es: "¿Necesita una cotización de malla personalizada?",
    de: "Benötigen Sie ein individuelles Gewebe-Angebot?",
    fr: "Besoin d'un devis pour une toile personnalisée ?",
    pt: "Precisa de uma cotação de malha personalizada?"
  });
  const lead = pick(lang, {
    en: "Get engineering-backed pricing for your exact filtration specification — mesh type, aperture, material grade, and volume.",
    zh: "根据您的精确过滤规格——网型、孔径、材质等级及采购量——获取工程支持的报价方案。",
    es: "Obtenga precios respaldados por ingeniería para su especificación exacta de filtración: tipo de malla, abertura, grado de material y volumen.",
    de: "Erhalten Sie technisch fundierte Preise für Ihre genaue Filtrationsspezifikation – Gewebetyp, Maschenweite, Werkstoffgüte und Menge.",
    fr: "Obtenez des tarifs basés sur l'ingénierie pour votre spécification exacte de filtration : type de toile, ouverture, nuance de matériau et volume.",
    pt: "Obtenha preços respaldados por engenharia para sua especificação exata de filtração — tipo de malha, abertura, grau do material e volume."
  });
  const secondaryLabel = pick(lang, {
    en: "Contact Our Team",
    zh: "联系工程团队",
    es: "Contacte con nuestro equipo",
    de: "Unser Team kontaktieren",
    fr: "Contacter notre équipe",
    pt: "Fale com nossa equipe"
  });
  return <CtaBand id="technicalquotecta" eyebrow={eyebrow} heading={heading} lead={lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: secondaryLabel,
    to: "/ContactPage",
    icon: Mail
  }} />;
}